import React, { useState, useEffect } from 'react';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
  Card,
  CardContent,
  Grid,
  Chip,
  Divider,
  IconButton,
  Box,
  Button,
  CircularProgress,
  Paper
} from '@material-ui/core';
import JobsiteSprayLogs from './JobsiteSprayLogs';
import { connect } from 'react-redux'
import { fade, makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import DashboardHeader from './HerbicideStuff/DashboardHeader'
import CompletedJobsDashboard from './HerbicideStuff/CompletedDashboard';
import Dashboard from './HerbicideStuff/SprayJobDashboard'

const useStyles = makeStyles(theme => ({
  root: {
    // width: '80%',
    margin: '10px',
  },
  paper: {
    width: '100%',
    height: '100%',
    minHeight: '80vh',
    padding: 10,
    marginBottom: theme.spacing(2),
  },
  grid: {
    // margin: '10px',
    // padding: '10px',
    // width: '95%'
  },
  topRowButton: {
    margin: 45,
    marginTop: 10,
    marginBottom: 10,
    width: 276
  },
  fuelTankHeader: {
    fontSize: '1.1em',
    fontWeight: 600,
    color: '#aaa'
  },
  fuelTankData: {
    color: '#888',
    fontSize: '.9em'
  },
  historicalFuelDataLine: {
    display: 'flex',
    justifyContent: 'space-evenly',
    flexDirection: 'row'
  },
  historicalFuelDataLineHeader: {
    fontSize: '1.1em',
    fontWeight: 600,
    color: '#aaa'
  },
  fuelTankData: {
    color: '#888',
    fontSize: '.9em'
  },
}))

const SprayLogDashboard = (props) => {
  const classes = useStyles();
  const [mtcSites, setMtcSites] = useState([])
  const [loading, setLoading] = useState(false)
  const [chemicals, setChemicals] = useState([])

  useEffect(() => {
    let isMounted = true

    const fetchAllMtcSites = async () => {
      setLoading(true)
      axios.get(`${props.url}/api/hmi/genericGetRequest?type=SPRAY_DASHBOARD_DETAILS`).then((response, status, data) => {
        setLoading(false)
        console.log('rep', response.data)
        if (response && response.data && response.data.data) {
        console.log('Spray Log Dahsboard', response.data)
          if (isMounted && response.data && response.data.data && response.data.data.sitesWithSprayLogs) {
            console.log('91...', response.data.data.sitesWithSprayLogs.allMergedSites)
            setMtcSites(response.data.data.sitesWithSprayLogs.allMergedSites)
          }
          console.log('Gotta set our other sites here somehow tooo...', response.data.data.otherSites)
          // let filteredSites = response
        }
        if (response.data.chemicals) {
          setChemicals(response.data.chemicals)
        }
      })
    }
    fetchAllMtcSites()

    return () => {
      isMounted = false
    }
  }, [])
  // console.log('Jobsites', mtcSites)
  return (
    <div className={classes.root}>
       <h1> Spray Log Dashboard</h1>
    <Paper className={classes.paper}>
     
     
      {/* <DashboardHeader url={props.url} /> */}
      {/* <CompletedJobsDashboard 
        url={props.url}
        jobsites={mtcSites} 
        chemicals={chemicals}
        /> */}

      {/* {
        loading ?  <CircularProgress size={64} /> :  <JobsiteSprayLogs jobsites={mtcSites} url={props.url} chemicals={chemicals} />
      } */}
     <Dashboard />
    </Paper>
    </div>
  )
}

const mapStateToProps = (state) => {
  // console.log('Do we have chemicals??', state)
  return {
    authenticated: state.authenticated,
    notification: state.notification,
    url: state.url,
    entities: state.entities,
    perms: state.perms
  }
}

export default connect(mapStateToProps)(SprayLogDashboard)
